import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getCustomerProfileById = createAsyncThunk(
  "customerProfileDetail/getCustomerProfileById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/customer/get_by_id`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const customerProfileSlice = createSlice({
  name: "customerProfileDetail",
  initialState: {
    loading: false,
    customerProfileDetailData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerProfileById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCustomerProfileById.fulfilled, (state, action) => {
        state.loading = false;
        state.customerProfileDetailData = action.payload;
      })
      .addCase(getCustomerProfileById.rejected, (state, action) => {
        state.loading = false;
        state.customerProfileDetailData = action.payload;
        state.error = action.payload;
      });
  },
});

export default customerProfileSlice.reducer;
